import { useLoadingOverlayStore } from '@/composables/useLoadingOverlayStore'
import { useApolloLoadingLink } from "@/apollo/useApolloLoadingLink.js";

export function useApolloOverlayLoadingLink(){

    const {
        getLoadingLink
    } = useApolloLoadingLink()

    const getDefaultOverlayLoadingLink = (pinia) => {

        const overlayStore = useLoadingOverlayStore(pinia)

        return getLoadingLink({
            showCallback : () => overlayStore.show(),
            hideCallback : () => overlayStore.hide(),
        })

    }

    const getPhpOverlayLoadingLink = (pinia) => {

        const overlayStore = useLoadingOverlayStore(pinia)

        return getLoadingLink({
            showCallback : () => {

                const preLoadingElement         = document.querySelector(".php-loading");

                if(preLoadingElement){
                    preLoadingElement.style.display = 'block';
                }


            },
            hideCallback : () => {

                const preLoadingElement         = document.querySelector(".php-loading");
                const preLoadingHeightElement   = document.querySelector(".php-loading-height");

                if(preLoadingElement){
                    preLoadingElement.style.display = 'none';
                }

                if(preLoadingHeightElement){
                    preLoadingHeightElement.style.display = 'none';
                }
            },
        })

    }

    return {
        getDefaultOverlayLoadingLink,
        getPhpOverlayLoadingLink
    }
}